import React, { useState } from "react";
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaInstagram,
  FaLinkedin,
  FaGithub,
} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import emailjs from "emailjs-com";
import { SERVICE_ID, TEMPLATE_ID, USER_ID } from "../Comman/Comman";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TbBrandLeetcode } from "react-icons/tb";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.phone) newErrors.phone = "Phone is required";
    if (!formData.message) newErrors.message = "Message is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const templateParams = {
        to_name: "Zaheer",
        from_name: formData.name,
        from_email: formData.email,
        from_phone: formData.phone,
        message: formData.message,
      };

      emailjs
        .send(SERVICE_ID, TEMPLATE_ID, templateParams, USER_ID)
        .then((response) => {
          if (response) {
            toast.success("Email successfully sent!");
            setFormData({ name: "", email: "", phone: "", message: "" });
            setErrors({});
          }
        })
        .catch((error) => {
          console.error("Failed to send email:", error);
          toast.error("Failed to send email");
        });
    }
  };

  return (
    <>
      <ToastContainer />
      <div
        className="container-fluid d-flex align-items-center justify-content-center bg-dark text-light"
        style={{ height: "auto", paddingTop: "20px", padding: "20px" }}
      >
        <div className="row w-100">
          <h1 className="text-center mb-5 w-100">Contact Us</h1>
          <div className="col-md-6 d-flex flex-column justify-content-center">
            <div
              className="border p-4 rounded mx-auto"
              style={{ maxWidth: "500px", flex: "1" }}
            >
              <h2 className="text-center">Get In Touch</h2>
              <p className="text-center">
                Please fill out the form below, and we'll get back to you as
                soon as possible!
              </p>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                  {errors.name && (
                    <div className="text-danger">{errors.name}</div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">Email *</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                  {errors.email && (
                    <div className="text-danger">{errors.email}</div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">Phone *</label>
                  <input
                    type="tel"
                    className="form-control"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                  {errors.phone && (
                    <div className="text-danger">{errors.phone}</div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">Message *</label>
                  <textarea
                    className="form-control"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                  {errors.message && (
                    <div className="text-danger">{errors.message}</div>
                  )}
                </div>
                <button type="submit" className="btn btn-primary w-100">
                  Submit
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-6 d-flex flex-column justify-content-center">
            <h3 className="mt-3">Contact Info</h3>
            <p>
              <FaPhone /> +91 7820931612 / 7447568726
            </p>
            <p>
              <FaEnvelope /> zaheerbaig242@gmail.com
            </p>
            <p>
              <FaMapMarkerAlt /> Katraj, Pune, 411046
            </p>
            <div className="mt-4">
              <h4>Follow Us</h4>
              <div>
                <a
                  href="https://www.instagram.com/mr_znb_off02/"
                  className="me-2"
                >
                  <FaInstagram size={25} />
                </a>
                <a
                  href="https://www.linkedin.com/in/zaheerbaigdeveloper"
                  className="me-2"
                >
                  <FaLinkedin size={25} />
                </a>
                <a href="https://github.com/zaheer1213" className="me-2">
                  <FaGithub size={25} />
                </a>
                <a href="https://leetcode.com/u/zaheer1213/">
                  <TbBrandLeetcode size={25} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
